<script>
    import Number from '/srv/web/wyvr/html/releases/58819/gen/client/form/Number.svelte?1733898724634';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let qty;
    export let min = 0;
    export let max = undefined;
    export let step = 1;

    let prev_qty;

    $: change(qty);

    function decrease() {
        update(qty - 1);
    }
    function increase() {
        update(qty + 1);
    }
    function update(value) {
        if (!isNaN(value) && value != null) {
            value = parseInt(value, 10);
            if (max != undefined) {
                value = Math.min(max, value);
            }
            if (min != undefined) {
                value = Math.max(min, value);
            }
            qty = value;
        }
    }
    function change(qty) {
        if (prev_qty == qty) {
            return;
        }
        dispatch('update', {
            qty,
            prev_qty,
        });
        prev_qty = qty;
    }
</script>

<div>

    {#if qty < 2}
        <button class="decrease icon-trash" on:click={decrease}></button>
    {:else}   
        <button class="decrease icon-minus" on:click={decrease}></button>
    {/if}
    <Number bind:value={qty} {min} {max} {step} />
    <button class="increase icon-plus" on:click={increase}></button>
</div>


<style>
    div {
        display: flex !important;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
    }
   
    button, div :global(input) {
        width: 60px !important;
        height: 30px !important;
    }

    button:first-child{
        border-right: none !important;
    }
    button:last-child{
        border-left: none !important;
    }

    button {
       background-color: transparent;
       color: #040B1C;
       border: 1px solid #040B1C;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px !important;
        height: 30px;
    }
    div :global(input) {
        border-right: 0 !important;
        border-left: 0 !important;
        text-align: center;
        width: 4rem !important;
        background-color: white !important;
    }
    div :global(.base) {
        width: 60px !important;
    }
    div :global(input) {
        border: 1px solid #040B1C !important;
        width: 60px !important;
        min-height: 30px !important;
    }
    .decrease {
        border-top-left-radius: calc(var(--size) * 0.25);
        border-bottom-left-radius: calc(var(--size) * 0.25);
    }
    .increase {
        border-top-right-radius: calc(var(--size) * 0.25);
        border-bottom-right-radius: calc(var(--size) * 0.25);
    }
</style>